export const FETCH_PRINT_PRICING_FOR_DESIGN_REQUEST =
  "API/ENTITIES/PRINT_PRICING/FETCH_FOR_DESIGN_REQUEST";
export const FETCH_PRINT_PRICING_FOR_DESIGN_REQUEST_SUCCESS =
  "API/ENTITIES/PRINT_PRICING/FETCH_FOR_DESIGN_REQUEST_SUCCESS";
export const FETCH_PRINT_PRICING_FOR_DESIGN_REQUEST_FAILURE =
  "API/ENTITIES/PRINT_PRICING/FETCH_FOR_DESIGN_REQUEST_FAILURE";
